import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Lightbox from 'react-images';
import Loading from 'layout/Loading';
import Thumbnail from './Thumbnail';

const styles = theme => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  paper: {
    width: 300,
    height: 267,
    [theme.breakpoints.down('xs')]: {
      height: 244,
    },
    display: 'table-cell',
    verticalAlign: 'unset !important',
  },
  centeredPaper: {
    width: 300,
    height: 267,
    [theme.breakpoints.down('xs')]: {
      height: 244,
    },
    display: 'table-cell',
    verticalAlign: 'middle',
  },
  title: {
    display: 'flex',
  },
});

export class PictureViewerBox extends Component {
  constructor() {
    super();

    this.state = {
      lightboxIsOpen: false,
      currentImage: 0,
    };

    this.closeLightbox = this.closeLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
    this.gotoImage = this.gotoImage.bind(this);
    this.handleClickImage = this.handleClickImage.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
  }

  openLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: true,
    });
  }

  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  }

  gotoPrevious() {
    const { currentImage } = this.state;
    this.setState({
      currentImage: currentImage - 1,
    });
  }

  gotoNext() {
    const { currentImage } = this.state;
    this.setState({
      currentImage: currentImage + 1,
    });
  }

  gotoImage(index) {
    this.setState({
      currentImage: index,
    });
  }

  handleClickImage() {
    const { currentImage } = this.state;
    const { imageUrls } = this.props;
    if (currentImage === imageUrls.length - 1) this.closeLightbox();
    this.gotoNext();
  }

  createLightBoxObjects(imageUrls) {
    return imageUrls.map(url => ({
      src: url,
      caption: url
        .split('/').pop()
        .split('_').join('\t')
        .split('.')[0],
      alt: 'Something went wrong while fetching the image.',
    }));
  }

  render() {
    const {
      classes, imageUrls, loading, title, displayPictureAmount,
    } = this.props;
    const { currentImage, lightboxIsOpen } = this.state;
    const hasData = imageUrls ? imageUrls.length > 0 : false;
    let imageObjects;
    if (hasData) imageObjects = this.createLightBoxObjects(imageUrls);
    return (
      <React.Fragment>
        <Typography className={classes.title} variant="subheading">
          {title}
        </Typography>
        <Paper className={hasData ? classes.paper : classes.centeredPaper}>
          {loading ? <Loading /> : (
            hasData ? (
              <React.Fragment>
                <Thumbnail
                  style={{ height: '100%', width: '100%' }}
                  imageUrls={imageUrls}
                  openLightbox={this.openLightbox}
                  displayPictureAmount={displayPictureAmount}
                />
                <Lightbox
                  images={imageObjects}
                  currentImage={currentImage}
                  isOpen={lightboxIsOpen}
                  onClickImage={this.handleClickImage}
                  onClickNext={this.gotoNext}
                  onClickPrev={this.gotoPrevious}
                  onClose={this.closeLightbox}
                  backdropClosesModal
                />
              </React.Fragment>
            )
              : 'No available pictures'
          )}
        </Paper>
      </React.Fragment>
    );
  }
}

PictureViewerBox.defaultProps = {
  loading: false,
  displayPictureAmount: false,
};

PictureViewerBox.propTypes = {
  imageUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  classes: PropTypes.shape({}).isRequired,
  loading: PropTypes.bool,
  displayPictureAmount: PropTypes.bool,
};

export default withStyles(styles)(PictureViewerBox);



// WEBPACK FOOTER //
// ./src/components/overview/PictureViewer/PictureViewerBox.jsx